<app-dialog [header]="title" (onClose)="close()" [dimensions]="{ width: 680, height: 220 }">
  <div class="help-internal-wrapper">
    <div class="help-content">
      @for (row of content; track row) {
        @if (row !== '[break]') {
          <p [innerHTML]="row"></p>
        }
        @if (row === '[break]') {
          <hr />
        }
      }
    </div>
  </div>
</app-dialog>
